// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  IAvailableRolloverToApplyResponse,
} from '../models/index';
import {
    IAvailableRolloverToApplyResponseFromJSON,
    IAvailableRolloverToApplyResponseToJSON,
} from '../models/index';

export interface GetAvailableRolloverToApplyRequest {
    claimId: number;
}

/**
 * ClaimRolloverControllerApi - interface
 * 
 * @export
 * @interface ClaimRolloverControllerApiInterface
 */
export interface ClaimRolloverControllerApiInterface {
    /**
     * 
     * @param {number} claimId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClaimRolloverControllerApiInterface
     */
    getAvailableRolloverToApplyRaw(requestParameters: GetAvailableRolloverToApplyRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<IAvailableRolloverToApplyResponse>>;

    /**
     */
    getAvailableRolloverToApply(requestParameters: GetAvailableRolloverToApplyRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<IAvailableRolloverToApplyResponse>;

}

/**
 * 
 */
export class ClaimRolloverControllerApi extends runtime.BaseAPI implements ClaimRolloverControllerApiInterface {

    /**
     */
    async getAvailableRolloverToApplyRaw(requestParameters: GetAvailableRolloverToApplyRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<IAvailableRolloverToApplyResponse>> {
        if (requestParameters['claimId'] == null) {
            throw new runtime.RequiredError(
                'claimId',
                'Required parameter "claimId" was null or undefined when calling getAvailableRolloverToApply().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/claims/{claim-id}/available-rollover-to-apply`;
        urlPath = urlPath.replace(`{${"claim-id"}}`, encodeURIComponent(String(requestParameters['claimId'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => IAvailableRolloverToApplyResponseFromJSON(jsonValue));
    }

    /**
     */
    async getAvailableRolloverToApply(requestParameters: GetAvailableRolloverToApplyRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<IAvailableRolloverToApplyResponse> {
        const response = await this.getAvailableRolloverToApplyRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
